import { ProductHitCard } from "./ProductHitCard";
import { ProductCardSkeleton } from "./ProductCardSkeleton";
import { useInfiniteProducts } from "@/frontend/algolia/hooks/useInfiniteProducts";
import { useScrollRestoration } from "@/frontend/algolia/hooks/useScrollRestoration";
import PromoComponent from "../../collection-list/CollectionTemplateComponents";
import { useHits } from "react-instantsearch";
import type { ProductHit } from "../product";

export default function InfiniteHits({ hitsPerPage, usePromo = false }: { hitsPerPage: number, usePromo?: boolean }) {
  const { items, isLoadingMore } = useInfiniteProducts({ hitsPerPage });
  const saveScrollPosition = useScrollRestoration(items.length > 0);
  const { sendEvent } = useHits();

  const handleProductClick = (hit: ProductHit) => {
    sendEvent('click', hit, 'Hit Clicked');
    saveScrollPosition();
  };

  return (
    <div className="tw-grid tw-auto-rows-fr tw-grid-cols-1 md:tw-grid-cols-2 xl:tw-grid-cols-3 tw-gap-5 [&_.PromoBoxWrapper]:tw-mb-5">
      {items.map((hit) => (
        <div key={hit.objectID} className="product-card mb-20">
          <ProductHitCard productHit={hit} onProductClick={() => handleProductClick(hit)} />
        </div>
      ))}

      {isLoadingMore &&
        Array.from({ length: hitsPerPage }).map((_, index) => (
          <div key={`skeleton-${index}`} className="product-card mb-20">
            <ProductCardSkeleton />
          </div>
        ))}

      {usePromo && <PromoComponent itemsLength={items.length} hitsPerPage={hitsPerPage} />}
    </div>
  );
}
